import React from 'react';
import { TableContainer, TableContainerProps } from '@mui/material';

/**
 * Conteneur de table avec scroll horizontal tactile (filet de sécurité mobile).
 */
const ResponsiveTableContainer: React.FC<TableContainerProps> = ({ sx, children, ...rest }) => (
  <TableContainer
    {...rest}
    sx={{
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      maxWidth: '100%',
      ...((sx as object) || {}),
    }}
  >
    {children}
  </TableContainer>
);

export default ResponsiveTableContainer;
